module.exports = __webpack_public_path__ + "img/web.99cb92a4.svg";